import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

const Wrapper = styled(motion.div)`
  ${({ theme }) => css`
    position: fixed;
    z-index: 999999;
    bottom: 0;
    left: 0;
    width: 100vw;
    background-color: #fff;
    text-align: center;
    max-height: 90vh;
    overflow-y: auto;

    ${theme.media('sm')} {
      padding: ${theme.spacing(5)} 0;
    }
  `}
`

const Content = styled.div<{ $length: number }>`
  ${({ theme, $length }) => css`
    display: grid;
    grid-template-columns: 1fr;
    justify-items: center;

    ${theme.media('sm')} {
      grid-template-columns: repeat(${$length}, 1fr);
    }

    h4 {
      margin-bottom: 0;

      ${theme.media('sm')} {
        margin-top: 0;
      }
    }

    div {
      padding: 0 ${theme.spacing(5)};
      text-align: initial;
    }

    div + div {
      border-top: 0.1rem solid ${theme.palette.grey[300]};

      ${theme.media('sm')} {
        border-top: none;
        border-left: 0.1rem solid ${theme.palette.grey[300]};
      }
    }

    img {
      display: block;
      max-width: 100%;
      height: auto;
      margin: auto;
    }
  `}
`

const Actions = styled.div`
  ${({ theme }) => css`
    ${theme.maxMedia('sm')} {
      position: sticky;
      bottom: 0;
      padding: ${theme.spacing(2)};
      background-color: #fff;
      border-top: 0.1rem solid ${theme.palette.grey[300]};
    }
  `}
`

const Backdrop = styled(motion.div)`
  ${({ theme }) => css`
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: ${theme.spacing(5)};
    background-color: rgba(0, 0, 0, 0.5);
    transition: background-color 200ms ease-in-out;
    will-change: background-color;

    &:hover {
      cursor: pointer;
      background-color: rgba(0, 0, 0, 0.7);
    }
  `}
`

export default {
  Wrapper,
  Content,
  Actions,
  Backdrop,
}
